/*
 * Get-addresses.ts
 * Description: Includes the declaration
 * of the get addresses
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store
import {store} from '@/config/plugins';

/**
 * Getting a list of addresses
 *
 * @return {Object} Promise - list of user addresses
 */
export function getAddresses() {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'addresses',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
                page: store.getters.currentPage,
            },
            data: {},
        }).then((response) => {
            // Setting the response in vuex
            store.dispatch('setResponse', response.data.data);
            // Setting the last page
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve(response.data.data);
        }).catch((error) => {
            reject(error);
        });
    });
}
